<template>
    <v-window v-model="step">
        <v-window-item value="default">
            <v-row no-gutters class="my-2">
                <v-col class="d-flex pb-2 pr-2" cols="12">
                    <v-text-field-filled
                        v-model="search"
                        label="Rechercher"
                        outlined
                        hide-details
                        density="compact"
                        append-inner-icon="$search"
                        clearable
                        @click:clear="search = ''"
                    />
                </v-col>
            </v-row>
            <v-list subheader style="height: 40vh; overflow: scroll" v-if="!loading" lines="two">
                <template v-if="!stockProducts.length && !search"> Aucun Produit ajouté </template>
                <template v-else-if="!filteredStockProducts.length">
                    Aucun résultat pour cet produit
                </template>
                <template v-else>
                    <v-list-item
                        v-for="(product, i) in filteredStockProducts"
                        :key="i"
                        class="mt-1 oss-list-item"
                        style="background: #fff"
                    >
                        <v-list-item-title>
                            {{ (product.title ? product.title + " - " : "") + product.reference }}
                        </v-list-item-title>
                    </v-list-item>
                </template>
            </v-list>
            <v-row v-else>
                <v-col cols="12" class="text-center">
                    <v-progress-circular indeterminate color="primary" />
                </v-col>
            </v-row>
        </v-window-item>
    </v-window>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["emit-upsert", "step", "edit-mode"],
})
export class StockProductTPCEdition extends Vue {
    @Prop({ required: true }) companyId!: string;
    @Prop({ required: true }) inThirdPartyCompanyId!: string;
    @Prop({ default: null }) actions: any;

    step = "default";

    search = "";

    productExists = false;

    loading = false;

    thirdPartyCompanyId_: string = "";

    get thirdPartyCompanyId() {
        if (this.thirdPartyCompanyId_) {
            return this.thirdPartyCompanyId_;
        }
        return this.inThirdPartyCompanyId;
    }

    set thirdPartyCompanyId(value) {
        this.thirdPartyCompanyId_ = value;
    }

    get filteredStockProducts() {
        if (!this.search) {
            return this.stockProducts;
        }
        return this.stockProducts.filter(
            (product) =>
                product.title.toLowerCase().includes(this.search.toLowerCase()) ||
                product.reference.toLowerCase().includes(this.search.toLowerCase()),
        );
    }

    @Apollo({
        query: gql`
            query products(
                $companyId: ID!
                $thirdPartyCompanyId: ID!
                $stock: Boolean!
                $type: InvoiceProductType!
            ) {
                invoiceProducts(
                    where: {
                        company: { id: $companyId }
                        stock: $stock
                        type: $type
                        OR: [
                            { thirdPartyCompany: { id: $thirdPartyCompanyId } }
                            { thirdPartyCompany: null }
                        ]
                    }
                ) {
                    id
                    reference
                    title
                    outDated
                    stock
                }
            }
        `,
        variables() {
            this.productLoading = true;
            return {
                companyId: this.companyId,
                stock: true,
                type: "EXPENSE",
                thirdPartyCompanyId: this.inThirdPartyCompanyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                this.productLoading = false;
                for (const p of data.invoiceProducts) {
                    if (p.outDated === null) {
                        p.outDated = true;
                    }
                }
                this.products = data.invoiceProducts.sort(function (x, y) {
                    return x.outDated === y.outDated ? 0 : x.outDated ? 1 : -1;
                });
            }
        },
    })
    products = [];

    @Apollo({
        query: gql`
            query companyStockProducts($thirdPartyCompanyId: ID!) {
                company(where: { id: $thirdPartyCompanyId }) {
                    id
                    name
                    isThirdPartyCompanyOfInvoiceProducts {
                        id
                        title
                        reference
                        stock
                        outDated
                    }
                }
            }
        `,
        variables() {
            return {
                thirdPartyCompanyId: this.inThirdPartyCompanyId,
            };
        },
        skip() {
            return !this.inThirdPartyCompanyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                this.productLoading = false;
                debugger;
                for (const p of data.company.isThirdPartyCompanyOfInvoiceProducts) {
                    if (p.outDated === null) {
                        p.outDated = true;
                    }
                }
                this.stockProducts = data.company.isThirdPartyCompanyOfInvoiceProducts
                    .sort(function (x, y) {
                        return x.outDated === y.outDated ? 0 : x.outDated ? 1 : -1;
                    })
                    .filter((x) => x.stock === true);
            }
        },
    })
    stockProducts = [];

    beforeMount() {
        if (this.actions && this.actions.action) {
            this.actions.action.function = this.updateThirdPartyProducts;
            this.actions.action.title = () => {
                return "Ajouter un produit";
            };
            this.actions.action.disabled = () => {
                return !this.stockProducts.length;
            };
            this.actions.action.display = () => {
                return true;
            };
        }
    }

    async updateThirdPartyProducts() {
        let listOfProducts = {
            connect: this.stockProducts.map((sp) => {
                return { id: sp.id };
            }),
        };
        debugger;
        const result = await this.$apollo.mutate({
            mutation: gql`
                mutation updateThirdPartyCompanyProducts(
                    $id: ID!
                    $stockProducts: InvoiceProductUpdateManyInput!
                ) {
                    updateCompany(
                        where: { id: $id }
                        data: { isThirdPartyCompanyOfInvoiceProducts: $stockProducts }
                    ) {
                        id
                    }
                }
            `,
            variables: {
                id: this.inThirdPartyCompanyId,
                stockProducts: listOfProducts,
            },
        });

        if (result?.data?.updateCompany) {
            this.thirdPartyCompanyId = result.data.updateCompany.id;
            this.$emit("emit-upsert", true);
        }
        this.step = "default";
    }

    emitStepFromComponent() {
        debugger;
        this.$emit("step", this.step);
    }

    emitEditMode() {
        this.$emit("edit-mode", true);
    }

    changeStep() {
        this.step = "default";
        this.$emit("step", this.step);
    }
}

export default toNative(StockProductTPCEdition);
</script>
